<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">
    {{ isUpdateForm ? "Update" : "Add" }} {{ imageName }} Image
  </h4>
  <i
    style="z-index: 1"
    class="bi bi-x-lg text-danger"
    color="warn"
    (click)="onClose()"
    title="Close"
  ></i>
</div>
<div style="width: 100%" class="modal-body text-grey">
  <form [formGroup]="fileImageForm" (ngSubmit)="submitForm()">
    <div style="width: 100%">
      <div
        style="
          width: inherit;
          margin-bottom: 15px;
          border-bottom: solid 1px;
          border-color: var(--bs-border-color);
          padding: 5px;
        "
      >
        <div
          style="display: flex; align-items: center; justify-content: center"
        >
          <label class="label-style text-grey" for="name">Name</label>
          <input
            style="font-size: 1.1em; color: var(--s-text-color)"
            class="form-control input-style"
            type="text"
            id="name"
            formControlName="name"
            required

          />
        </div>
        <div
          class="error-message"
          *ngIf="
            fileImageForm.get('name').invalid &&
            (fileImageForm.get('name').dirty ||
              fileImageForm.get('name').touched)
          "
        >
          <small *ngIf="fileImageForm.get('name').errors.required"
            >Name is required.</small
          >
        </div>
      </div>

      <div
        style="
          width: inherit;
          margin-bottom: 15px;
          border-bottom: solid 1px;
          border-color: var(--bs-border-color);
          padding: 5px;
        "
      >
        <div
          style="display: flex; align-items: center; justify-content: center"
        >
          <label class="label-style" for="infrastructure">Infrastructure</label>
          <input
            style="font-size: 1.1em"
            class="form-control input-style"
            type="text"
            id="infrastructure"
            formControlName="infrastructure"
          />
        </div>
      </div>

      <div class="field-container">
        <div class="inner-field-container">
          <label class="label-style" for="friendlyName">Friendly Name</label>
          <input
            style="font-size: 1.1em"
            class="form-control input-style"
            type="text"
            id="friendlyName"
            formControlName="friendlyName"
          />
        </div>
      </div>

      <div class="field-container">
        <div class="inner-field-container">
          <label class="label-style" for="path">Path</label>
          <input
            style="font-size: 1.1em"
            class="form-control input-style"
            type="text"
            id="path"
            formControlName="path"
          />
        </div>
      </div>

      <div class="field-container">
        <div class="inner-field-container">
          <label class="label-style" for="size">Size</label>
          <input
            style="font-size: 1.1em"
            class="form-control input-style"
            type="text"
            id="size"
            formControlName="size"
          />
        </div>
      </div>

      <div class="field-container">
        <div class="inner-field-container">
          <label class="label-style" for="format">Format</label>
          <input
            style="font-size: 1.1em"
            class="form-control input-style"
            type="text"
            id="format"
            formControlName="format"
          />
        </div>
      </div>

      <div class="field-container">
        <div class="inner-field-container">
          <label class="label-style" for="platform">Platform</label>
          <input
            style="font-size: 1.1em"
            class="form-control input-style"
            type="text"
            id="platform"
            formControlName="platform"
          />
        </div>
      </div>

      <div class="field-container">
        <div class="inner-field-container">
          <label class="label-style" for="description">Description</label>
          <textarea
            style="font-size: 1.1em"
            class="form-control input-style"
            id="description"
            formControlName="description"
          ></textarea>
        </div>
      </div>

      <div
        style="
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: end;
        "
      >
        <div
          style="
            width: 30%;
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <button class="btn btn-secondary" (click)="onClose()">Cancel</button>
          <button
            class="btn btn-primary"
            type="submit"
            [disabled]="fileImageForm.invalid"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
